<template>
    <div class="myPopup" v-if="popupShow">
        <div class="popup-info">
            <div class="title">
                <h2>{{title}}</h2>
            </div>
            <div class="item" v-for="(value,index) in data" v-bind:key="index">
                <p style="font-size: 18px;margin-left: 20px;text-indent: -30px">{{value}}</p>
            </div>
        </div>
        <div class="popup-close" @click="popupShow=false">
            <i class="iconfont icon-round_close_light" style="color: #FFF;font-size: 50px"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MyPopup",
        data(){
            return{
                popupShow:false,
            }
        },
        props:{
            data:null,
            title:null
        }
    }
</script>

<style scoped lang="scss">
    .myPopup{
        background: rgba(0,0,0,0.4);
        position: relative;
        width: 100%;
        height: 100%;
        animation:fadenum 0.5s ease-in;
    .popup-info{
        position: absolute;
        left: 10%;
        right: 10%;
        top: 20%;
        width: 80%;
        height: 50%;
        background: #FFF;
        border-radius: 10px;
        .title{
            font-size: 12px;
        }
        .item{
            font-size: 11px;
            /*background: red;*/
            text-align: left;
            margin: 0 15px;
            white-space: normal;
        }
    }
    .popup-close{
        position: absolute;
        left: 10%;
        right: 10%;
        bottom: 20%;
    }
    }

    @keyframes fadenum{
        0%{opacity: 0;}
        100%{opacity: 1;}
    }
</style>